import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FooterService {
    isFooterVisible = new BehaviorSubject<boolean>(false);
    isFooterVisible$ = this.isFooterVisible.asObservable();

    setFooterVisibility(isVisible: boolean): void {
        this.isFooterVisible.next(isVisible);
    }
}
